<!--Получает дерево, имеет 4 дочерних элемента двум из которых передаётся полученное дерево так же от gap
получает regionId и activeYear, которые передаёт всем дочерним элементам, вызывает уведомление
над всеми дочерними элементами если текущий год - 1 = выбранному-->
<template>
  <div>
    <v-container style="word-wrap: break-word; margin-left: 5px; max-width: initial; max-height: initial">
      <v-alert v-if="activeYear === getYear"
        border="top"
        colored-border
        type="warning"
        elevation="2">
         Сведения по территории данного муниципального образования за {{getYear}} год находятся на стадии формирования
      </v-alert>
      <v-layout row wrap>
        <v-flex md6 sm6>
          <region-info :region-id="region" :active-year = "activeYear"/>
          <selected-region-tree style="margin-right: 10px" :region-id = "region" :active-year = "activeYear" :tree = "tree"/>
          <search-table style="margin-right: 10px" :region-id="region" :active-year = "activeYear" :tree="tree" :searched-prop="searched"/>
        </v-flex>
        <v-flex md6 sm6 xs12 style="padding-left: 20px; padding-top: 22px;">
          <region-map :guest="guest" :region-id="region" :active-year = "activeYear" :municipality-name="municipalityName"/>
        </v-flex>
      </v-layout>
    </v-container>
    <region-table id="table"/>
  </div>
</template>

<script>

import SelectedRegionTree from "@/components/selected-region-tree";
import SearchTable from "@/components/search-table";
import RegionInfo from "@/components/region-info";
import RegionMap from "@/components/region-map";
import RegionTable from "@/components/region-table";
import axios from "axios";

export default {
  name: "RegionPage",
  components: {
    "selected-region-tree": SelectedRegionTree,
    "search-table": SearchTable,
    "region-info": RegionInfo,
    "region-map": RegionMap,
    "region-table": RegionTable,
  },
  props: {
    guest: Boolean,
    region: Number,
    activeYear: Number,
    municipalityName: String,
    searched: String
  },
  data() {
    return {
      tree: []
    };
  },
  computed: {
    getYear () {
      let currentDate = new Date()
      return currentDate.getFullYear() - 1
    }
  },
  methods: {
    loadMunicipality(year) {
      this.tree = []
      axios
        .post("/eco-passport/get-tree", {year})
        .then(response => {
          this.tree = response.data
        })
        .catch(e => alert(e.toString()));
    }
  },
  created() {
    this.loadMunicipality(this.activeYear)
  },
};
</script>

<style scoped></style>
